function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "transparent",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,95.686275%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 20.183594 1.089844 L 3.816406 1.089844 C 2.3125 1.089844 1.089844 2.3125 1.089844 3.816406 L 1.089844 20.183594 C 1.089844 21.6875 2.3125 22.910156 3.816406 22.910156 L 20.183594 22.910156 C 21.6875 22.910156 22.910156 21.6875 22.910156 20.183594 L 22.910156 3.816406 C 22.910156 2.3125 21.6875 1.089844 20.183594 1.089844 Z M 20.183594 1.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,10.588235%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 21.089844 1.089844 L 17.453125 1.089844 C 16.449219 1.089844 15.636719 1.90625 15.636719 2.910156 L 15.636719 6.546875 C 15.636719 7.550781 16.449219 8.363281 17.453125 8.363281 L 21.089844 8.363281 C 22.09375 8.363281 22.910156 7.550781 22.910156 6.546875 L 22.910156 2.910156 C 22.910156 1.90625 22.09375 1.089844 21.089844 1.089844 Z M 21.089844 1.089844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/topRight.82ef4f6a222ae78250c2685c3be669c3.svg";
export { ForwardRef as ReactComponent };